import { FunctionComponent, useEffect, useState } from "react"
import { Select } from "react-daisyui"

type OptionWithValueType = {
  value: string
  label: string
}

type LoginDropdownType = {
  id: string
  titleText: string
  placeholderText: string
  options: OptionWithValueType[]
  required?: boolean
  error?: string
  setValue?: (value: string) => void
  defaultValue?: string
  showNoneOption?: boolean
  disable?: boolean
}

const LoginDropdown: FunctionComponent<LoginDropdownType> = ({
  id,
  titleText,
  placeholderText,
  options,
  required,
  error,
  setValue,
  defaultValue = "",
  showNoneOption = false,
  disable = false,
}) => {
  const [clearError, setClearError] = useState(false)
  const [selectedValue, setSelectedValue] = useState(defaultValue)
  const handleChange = (e: { target: { value: string } }) => {
    const { value } = e.target

    if (setValue) {
      if (value === "none") {
        setSelectedValue("")
      } else {
        setSelectedValue(value)
      }
      setValue(value)

      // Clear error when text is entered
      if (!clearError) {
        setClearError(true)
      }
    }
  }

  useEffect(() => {
    setSelectedValue(defaultValue)
  }, [defaultValue])

  return (
    <div className="items-start w-full justify-start gap-[6px] text-left text-sm text-gray-700 font-text-md-regular1">
      <div className="self-stretch w-full flex flex-col items-start justify-start gap-[6px]">
        <label
          htmlFor={id}
          className="relative w-full leading-[24px] font-medium">
          {titleText}
          <Select
            id={id}
            data-testid={id}
            className="self-stretch w-full rounded-lg bg-base-white shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] overflow-hidden flex flex-row px-3.5 items-center justify-start gap-[8px] text-base text-gray-500 border-[1px] border-solid border-gray-300"
            // placeholder={placeholderText}
            required={required}
            value={selectedValue}
            disabled={disable}
            onChange={handleChange}>
            <Select.Option value="" disabled hidden>
              {placeholderText}
            </Select.Option>
            <Select.Option hidden={!showNoneOption} value="none">
              None
            </Select.Option>
            {options.map((option, index) => (
              <Select.Option key={index} value={option.value}>
                {option.label}
              </Select.Option>
            ))}
          </Select>
          {error && !clearError && (
            <div className="text-red-500 text-sm">{error}</div>
          )}
        </label>
      </div>
    </div>
  )
}

export default LoginDropdown
